export const notifyPartnersDividendsModalInitValue = {
  data: {
    partnersData: [],
    totalPartners: 0,
    expandView: false,
    expandDirection: 'down',
    hasInvalidEmails: false,
    invalidEmailsAlert: undefined,
    hasGeneratedEmails: false,
    generatedEmailsAlert: undefined,
    currentPage: 1,
    rowsPerPage: 10,
    isLoading: false,
  },
  actions: {
    handleChangeView(): void {},
    handleCloseModal(): void {},
    handleSendEmails(): void {},
    handleSendTestEmail(): void {},
    handleChangePage(): void {},
    handleChangeRowsPerPage(): void {},
  },
};
